import React, { useState } from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import Text from '../../../../../Components/Base/Text/Text';
import { Theme } from '../../../../../Enums/Theme.enum';
import Button from '../../../../../Components/Button/Button';
// @ts-ignore
import styles from './ServiceScheduleInstructionsModal.module.scss';
import Checkbox from '../../../../../Components/Base/Checkbox/Checkbox';
import LocalStorage from '../../../../../Services/LocalStorage';
import { doNotShowHintAgain } from '../../../Services/manager.service';
import { useAppContext } from '../../../../../Services/AppContext';

interface Props {
	isOpened: boolean;
	onClose: () => void;
}

const ServiceScheduleInstructionsModal: React.FC<Props> = ({
	isOpened,
	onClose,
}) => {
	const { isLatam } = useAppContext();
	const [doNotShowAgain, setDoNotShowAgain] = useState(false);
	const handleContinue = () => {
		if (doNotShowAgain) {
			doNotShowHintAgain('doNoShowServiceScheduleInstructionsModal');
		}
		onClose();
	};

	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.SM}>
			<Modal.Header
				title='component.serviceScheduleInstructionsModal.title'
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<div className={styles.wrapper}>
					{!isLatam && (
						<Text
							tx='component.serviceScheduleInstructionsModal.text2'
							className={styles.textBold}
						/>
					)}
					<Text tx='component.serviceScheduleInstructionsModal.text1' />
					{isLatam && (
						<Text tx='component.serviceScheduleInstructionsModal.text2' />
					)}
					<Text tx='component.serviceScheduleInstructionsModal.text3' />
					<Checkbox
						value={doNotShowAgain}
						onChange={() => setDoNotShowAgain(!doNotShowAgain)}
						tx='component.serviceScheduleInstructionsModal.checkbox'
					/>
					<div className={styles.controls}>
						<Button
							theme={Theme.GREEN}
							title='component.serviceScheduleInstructionsModal.button'
							onClick={handleContinue}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ServiceScheduleInstructionsModal;
